/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: content.ts
 * Project: mle-client
 * Committed last: 2021/10/14 @ 1522
 * ---
 */

export const defaultRequiredMessage = 'Campo richiesto';
